import Button from '@jetbrains/ring-ui/components/button/button'
import Input from '@jetbrains/ring-ui/components/input/input'
import {useState, useCallback} from 'react'
import * as React from 'react'

import {restApi} from '../../../../services/rest'
import {downloadFile} from '../../../../utils/download'
import {extractError} from '../../../../utils/extractError'

import styles from './DownloadConfig.css'

export default function DownloadConfig() {
  const [fetchAgentConfig, {error, loading}] = restApi.endpoints.generateAgentConfig.useMutation({
    selectFromResult: ({error, isLoading}) => ({error, loading: isLoading}),
  })
  const extractedError = extractError(error)

  const [value, setValue] = useState('')
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setValue(e.currentTarget.value)
    },
    [setValue],
  )
  const handleClear = useCallback(() => {
    setValue('')
  }, [setValue])
  const generate = useCallback(async () => {
    const result = await fetchAgentConfig(value)
    if ('data' in result) {
      downloadFile(result.data, 'buildAgent.properties', 'text/plain')
    }
  }, [fetchAgentConfig, value])
  return (
    <div>
      <p>
        {
          'Enter an agent name and generate a configuration file with an auth token inside. Use it to launch a new agent. The server will authenticate this agent automatically.'
        }
      </p>
      <div>
        <Input
          type="text"
          label={'Agent name'}
          name="agent"
          inputClassName={styles.input}
          value={value}
          onChange={handleChange}
          onClear={handleClear}
        />
      </div>
      <Button loader={loading} onClick={generate} primary>
        {'Generate & download'}
      </Button>
      {!loading && error != null && (
        <div className={styles.error}>
          {typeof extractedError === 'string' ? extractedError : extractedError?.message}
        </div>
      )}
    </div>
  )
}
